import { render } from "./ActionButtons.vue?vue&type=template&id=82723f4c&scoped=true"
import script from "./ActionButtons.vue?vue&type=script&lang=js"
export * from "./ActionButtons.vue?vue&type=script&lang=js"

import "./ActionButtons.vue?vue&type=style&index=0&id=82723f4c&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82723f4c"]])

export default __exports__